import { useState } from "react"
import Header from "../../components/custom/header"
import Icon from "../../components/custom/icon"
import Modal from "../../components/holders/modal"
import Form from "../../components/custom/form"
import "./index.css"
import { getCreateCLConfig } from "../../data/callinglist"

const CallingList = props => {

    const [showModal, setShowModal] = useState(false)

    return (
        <div className="cl-root">
            <Header title={'Calling List'} />

            <div className="body">
                <div className="cl-plus" onClick={() => { setShowModal(true) }}>
                    <Icon name='add' color='white' />
                </div>
            </div>

            {showModal ?
                <Modal title={'Create Calling List'} close={() => { setShowModal(false) }}>
                    <div className="cp-create-cont">
                        <Form config={getCreateCLConfig()} onSubmit={v => console.log(v)} />
                    </div>
                </Modal>
                : null
            }

        </div>
    )
}

export default CallingList